import { AspectRatio, Box, Skeleton, Stack } from '@inflearn/ds-react';

import { COURSE_CARD_THUMBNAIL_RATIO } from './CourseCard/CourseThumbnail';
import { styleListContainer } from './CourseCardContainer';

export function CourseCardContainerSkeleton() {
  return (
    <Box css={styleListContainer}>
      <CourseCardSkeleton />
      <CourseCardSkeleton />
      <CourseCardSkeleton />
      <CourseCardSkeleton />
      <CourseCardSkeleton />
      <CourseCardSkeleton />
    </Box>
  );
}

export function CourseCardSkeleton() {
  return (
    <Stack spacing={8}>
      <AspectRatio ratio={COURSE_CARD_THUMBNAIL_RATIO}>
        <Skeleton radius={8} />
      </AspectRatio>
      <Skeleton radius={8} h={16} />
      <Skeleton radius={8} h={8} />
      <Skeleton radius={8} h={37} w={160} />
      <Skeleton radius={8} h={36} w={80} />
    </Stack>
  );
}
